import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ModalsContext } from '../../contexts/ModalsContext';
import { AlertContext } from '../../contexts/AlertContext';
import { SocketContext } from '../../contexts/SocketContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { CreateServiceForm } from '../../components/surveys/services/CreateServiceForm';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { Actions } from '../../components/surveys/services/Actions';
import { useModalStore } from '../../store/useModalStore';

const columns = [
    { id: "servicio", label: "Servicio", minWidth: 170, align: 'center' },
    { id: "estado", label: "Estado", minWidth: 170, align: 'center' },
    { id: "acciones", label: "Acciones", minWidth: 170, align: 'center' }
];

export const useServices = () => {

    const [services, setServices] = useState([]);

    // const { modalRef } = useContext(ModalsContext);
    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { openModal, closeModal } = useModalStore();

    useEffect(() => {
        let subscribed = true;
        
        if(subscribed) 
            setOpenLoader(true);
            getServices();

        return () => subscribed = false;
    }, []);

    const searchService = (value) => { 
        socket.emit('frontend:buscar-servicio', { servicio: value?.trim() }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                alertRef.current?.handleOpen('error', message);
                return;
            }
          
            setServices(data?.map(d => generatePayload(d)));
        });
    }

    // const addService = () => {
    //     modalRef.current.handleOpen(<CreateServiceForm action={ (data) => saveService(data)  } />, 'auto', 'auto');
    // }

    const addService = () => openModal(<CreateServiceForm action={ (data) => saveService(data)  } />)

    const getServices = useCallback(() => {
        socket.emit('frontend:obtener-servicios', (response) => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }

            const newArr = data?.map(generatePayload);
            setServices(newArr);
            setOpenLoader(false);
        });
    }, []);

    const saveService = (args) => {
        setOpenLoader(true);
        socket.emit('frontend:crear-servicio', { 
            servicio: args.servicio?.trim(),
        }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setServices(prev => ([...prev, generatePayload(data)]));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const updateService = (args) => {
        setOpenLoader(true);
        const { _id, servicio, activo } = args;
        socket.emit('frontend:actualizar-servicio', { _id, servicio: servicio?.trim(), activo: Boolean(activo) }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }
            
            setServices(prev => prev?.map(p => p?._id === _id ? generatePayload(data) : p ));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const deleteService = (_id) => {
        setOpenLoader(true);
        socket.emit('frontend:eliminar-servicio', { _id }, response => {
            const { ok, message } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setServices(prev => prev?.filter(p => p._id !== _id));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const generatePayload = (data) => ({
        ...data,
        servicio: convertirLetraMayus(data?.servicio),
        estado: data?.activo ? 'Activo' : 'Inactivo',
        acciones: <Actions data={ data } updated={ updateService } deleted={ deleteService } />
    });

    return {
        columns,
        services,
        addService,
        searchService
    }
}